<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row align="center">
      <v-card>
        <v-row>
          <v-col cols="6">
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
          </v-col>
        </v-row>

        <v-row>
          <!-- Tabela da esquerda: catálogo de periodicidades -->
          <v-col cols="6">
            <v-data-table
              :headers="headers"
              :items="filteredList"
              class="elevation-1"
              :loading="loading"
              loading-text="Buscando dados..."
              :search="search"
              :footer-props="{
                showFirstLastPage: true,
                itemsPerPageText: 'Items por página',
                itemsPerPageOptions: [-1],
              }"
            >
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small type="button" @click="addPeriodo(item)" v-bind="attrs" v-on="on">
                      <v-icon color="green">mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar Período</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>

          <!-- Tabela da direita: lista adicionada (periodoL) -->
          <v-col cols="6">
            <v-data-table
              :headers="headers"
              :items="periodoL"
              class="elevation-1"
              :loading="loading"
              loading-text="Buscando dados..."
              :search="search"
              :footer-props="{
                showFirstLastPage: true,
                itemsPerPageText: 'Items por página',
                itemsPerPageOptions: [-1],
              }"
            >
              <!-- pegue também o index para remover corretamente -->
              <template v-slot:item.actions="{ item, index }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small type="button" @click="removerPeriodo(index)" v-bind="attrs" v-on="on">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover período</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "periodo",
  props: {
    periodoL: { type: Array, default: () => [] }, // virá do pai via .sync
    showModal: Boolean,
  },
  data: () => ({
    search: "",
    valid: true,
    errorMessage: false,
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "Descrição", value: "descricao" },
      { text: "Quantidade Horas", value: "quantidadeHoras" },
    ],
  }),
  computed: {
    ...mapState("periodicidade", ["periodicidades"]),
    periodosAdicionados() {
      return (this.periodoL || []).map((p) => p.idPeriodicidade);
    },
    filteredList() {
      const s = this.search.toLowerCase();
      return (this.periodicidades || []).filter((p) =>
        (p.ativo === true) &&
        (
          p.id.toString().toLowerCase().includes(s) ||
          (p.descricao || "").toLowerCase().includes(s)
        ) &&
        !this.periodosAdicionados.includes(p.id)
      );
    },
    loading() {
      return !(this.periodicidades && this.periodicidades.length > 0);
    },
  },
  methods: {
    updateObjectEstate() { return this.$refs.form.validate(); },
    clear() { this.$refs.form.reset(); this.$refs.form.resetValidation(); },

    addPeriodo(p) {
      const novo = {
        idPeriodicidade: p.id,
        descricao: p.descricao,
        quantidadeHoras: p.quantidadeHoras,
        index:
          (this.periodoL && this.periodoL.length)
            ? this.periodoL[this.periodoL.length - 1].index + 1
            : 0,
      };

      // NUNCA mutar prop diretamente — crie nova lista e emita update
      const novaLista = [...(this.periodoL || []), JSON.parse(JSON.stringify(novo))];
      this.$emit('update:periodoL', novaLista);
    },

    removerPeriodo(index) {
      const novaLista = (this.periodoL || []).slice();
      if (index >= 0 && index < novaLista.length) {
        novaLista.splice(index, 1);
        this.$emit('update:periodoL', novaLista);
      }
    },
  },
};
</script>